module.exports = __webpack_public_path__ + "static/media/fig_22.14199243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_22.jpg
// module id = 657
// module chunks = 0